import {OfferAsset} from 'models/offer-asset';
import {OfferAssetType} from 'models/offer-asset-type';
import {OfferPage} from 'models/offer-page';
import { OfferPageCategory } from 'models/offer-page-category';
import {OfferLocaleContent} from '../../models/offer-locale-content';
import {OfferLocaleKey} from '../../models/offer-locale-key';
import {OfferProduct} from '../../models/offer-product';
import {OfferProductLocaleContent} from '../../models/offer-product-locale-content';
import {OfferProductLocaleKey} from '../../models/offer-product-locale-key';
import {OfferProductPrice} from '../../models/offer-product-price';
import {Agent, request} from './base';

export class OfferAgent {
    assets = new Agent(OfferAsset, '/offer/assets');
    assetTypes = new Agent(OfferAssetType, '/offer/assets/types');

    disableAsset = async (name: string) => {
        await request.del(`/offer/assets/${name}`);
    };

    pages = new Agent(OfferPage, '/offer/pages');
    categories = new Agent(OfferPageCategory, '/offer/pages/categories');

    sync = async () => {
        await request.post('/offer/pages/sync', {});
    };

    createPage = async () => {
        const res = await request.post('/offer/pages', {});
        return new OfferPage(res);
    };

    clonePage = async (id: number) => {
        await request.post(`/offer/pages/clone/${id}`, {});
    };

    deletePage = async (id: number) => {
        await request.del(`/offer/pages/${id}`, {});
    };

    localeKeys = new Agent(OfferLocaleKey, '/offer/locales/keys');
    localeContent = new Agent(OfferLocaleContent, '/offer/locales/content');

    syncProductPrices = async () => {
        await request.post('/offer/products/prices/sync', {});
    };

    products = new Agent(OfferProduct, '/offer/products');
    productPrices = new Agent(OfferProductPrice, '/offer/products/prices');
    productLocaleKeys = new Agent(OfferProductLocaleKey, '/offer/products/locales/keys');
    productLocaleContent = new Agent(OfferProductLocaleContent, '/offer/products/locales/content');
}
